import { IScaleParams } from '../models/scale-params.interface';
import { fragSampler } from '../shaders/frag-sampler.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { TexturePipelineBase } from './pipeline-texBase';

export class ScaledTexturePipeline extends TexturePipelineBase {
  public scaleParams: IScaleParams;

  public constructor(scaleParams: IScaleParams) {
    super(vertSampler, fragSampler);

    this.scaleParams = scaleParams;
  }

  public Init(canvasWidth: number, canvasHeight: number, gl?: WebGLRenderingContext): void {
    let scaleX = this.scaleParams.widthPct || 1;
    let scaleY = this.scaleParams.heightPct || 1;

    if (this.scaleParams.widthPct === undefined && this.scaleParams.widthToPx !== undefined) {
      scaleX = this.scaleParams.widthToPx / canvasWidth;
    }

    if (this.scaleParams.heightPct === undefined && this.scaleParams.heightToPx !== undefined) {
      scaleY = this.scaleParams.heightToPx / canvasHeight;
    }

    const outputWidth = Math.max(1, Math.round(canvasWidth * scaleX));
    const outputHeight = Math.max(1, Math.round(canvasHeight * scaleY));

    super.Init(outputWidth, outputHeight, gl);
  }

  // ! The scaled canvas naturally scales the image because of the uv mapping of the texture, already a proportional fit.
  // ! So this just ends up creating an extra zoom effect.
  // get TransformMatrix():number[] {
  //   return [
  //     this.scaleX, 0, 0, 0,
  //     0, this.scaleY * this.FlipYValue, 0, 0,
  //     0, 0, 1, 0,
  //     0, 0, 0, 1
  //   ];
  // }
}
